module.exports = __webpack_public_path__ + "img/logic_logo_черный_eng.ba7da13f.svg";